<script setup>
  defineOptions({
    name: "MergeAccountIconGroup",
  });
</script>

<template>
  <figure class="md:scale-75 lg:scale-100">
    <div class="flex items-end justify-center space-x-2">
      <slot />
    </div>
  </figure>
</template>
